<script>
export default {
  name: 'FirstTime',
  computed: {
    user () {
      return this.$store.state.user 
    },
    hasPaid () {
      return this.user.application_status === 'FULLY_PAID'
    },
  },
}
</script>

<template lang="pug">
  #first-time-main.modal-main
    .first-time-container.modal-container
      .title Welcome!
      .content
        .copy.thanks Thank you for signing up with South Bend Code School!
        .party-face
          img(
            src='@/assets/img/Party Face Emoji.png'
          )
        .copy.success(
          v-if='hasPaid'
        ) Your payment was successful and you are fully registered!
        .copy.success(
          v-else
        ) Your application was received and we will respond to your request within 48 hours.
        .copy Please fill out all paperwork before the first coding session.
      .action
        .button(
          @click='$modals.hide("first-time")'
        ) Continue

</template>

<style lang="sass" scoped>
  #first-time-main
    .first-time-container
      .content
        padding: 2rem
        .party-face
          width: 200px
          margin: 2rem auto 2rem
          > img
            width: 100%
        .copy
          font-size: 18px
          margin-bottom: 1rem
          &.thanks
            font-size: 24px
            text-align: center
            font-weight: bold
          &.success
            font-weight: bold
      .action
        .button
          width: 16rem
          margin: 0 auto
</style>